import { ComponentProps, RefObject, useState } from 'react';

import { OpModal } from 'new-components/DLS/OpModal/OpModal';

import './scss/useFrameModal.scss';

interface FrameModalProps extends ComponentProps<typeof OpModal> {
  frameRef?: RefObject<HTMLIFrameElement>;
  url?: string;
  width: number;
  height: number;
  title: string;
  modalTitle?: string;
}

export const useFrameModal = ({
  frameRef,
  height,
  title,
  url,
  width,
  ...opModalProps
}: FrameModalProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { onCancel, onOk, modalTitle, ...rest } = opModalProps;

  const FrameModal = (
    <OpModal
      className="iframe-modal"
      height={height}
      width={width}
      open={isOpen}
      testId="iframe-modal"
      onCancel={(e) => {
        onCancel?.(e);
        setIsOpen(false);
      }}
      onOk={(e) => {
        onOk?.(e);
        setIsOpen(false);
      }}
      title={modalTitle}
      {...rest}
    >
      <div className="iframe-modal__container">
        {url && ( // Hopefully solve blank iframe issue
          <iframe
            className="iframe-modal__iframe"
            src={url}
            allow="autoplay"
            width={width}
            height={height}
            title={title}
            ref={frameRef}
          />
        )}
      </div>
    </OpModal>
  );

  return {
    FrameModal,
    openModal: () => setIsOpen(true),
    closeModal: () => setIsOpen(false),
  };
};
